module.exports = __webpack_public_path__ + "images/job/detail/detail_icon03-7614cd3bf2fe65ced1f12bd848225748.png";